module.exports = __webpack_public_path__ + "static/media/group-222.a56a2d36.svg";